<template>
  <div class="product_module">
    <div>
      <img :src="productBannerImg" width="100%" alt="">
    </div>
    <div class="product_module_items front_view_font">
      <el-row :gutter="40">
        <el-col :span="12" v-for="(item,index) in proMArr" :key="index">
          <div class="p_m_item" :class="{ high_light:activeIndex===index }" @click="productModuleShow(index)">
            <div class="mianTitle">{{item.name}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="product_show">
      <div v-if="isSoftware">
        <software-obj ref="softModule"></software-obj>
      </div>
      <div v-if="!isSoftware">
        <define-obj v-bind:productId='productId' ref="definemodule"></define-obj>
      </div>
    </div>
  </div>
</template>
<script>
import IMGSTATION from '../../../common/util/imgStation'
import defineObj from './defineObj';
import softwareObj from './softwareObj';
import { eventBus } from '../../../common/util/eventBus.js';
export default {
  data() {
    return {
      productBannerImg: IMGSTATION.productModule.banner,
      proMArr: [
        {
          name: '产品展示'
        },
        {
          name: '技术方案'
        }
      ],
      proType: 0,
      isSoftware: false,
      productId: '',
      activeIndex: 0
    };
  },
  components: {
    defineObj,
    softwareObj
  },
  created() {
    if (this.getProTypeRoter()) {
      this.proType = this.getProTypeRoter();
    } else {
      eventBus.$on('proMdulePlayer', message => {
        if (message) this.proType = message;
        else this.proType = 0;
      });
    }
    this.productId = this.getProductIdRouter();
  },
  mounted() {
    this.productModuleShow(this.proType);
    if (this.productId) this.$refs.definemodule.viewProduct(this.productId);
  },
  watch: {
    proType: {
      handler(newVal) {
        this.productModuleShow(this.proType);
      },
      deep: true
    }
  },
  methods: {
    productModuleShow(index) {
      this.activeIndex = index
      index === 0 ? this.isSoftware = false : this.isSoftware = true;
    },
    getProTypeRoter() {
      let tempType = null;
      if (this.$route.params.proType) tempType = this.$route.params.proType;
      return tempType;
    },
    getProductIdRouter() {
      let tempId = null;
      if (this.$route.params.productId) tempId = this.$route.params.productId;
      return tempId;
    }
  }
};
</script>
<style lang="stylus" scoped>
.product_module {
  width: 100%;
  background-color: #fff;
  z-inex: 10;
  position: relative;
  min-height: 600px;
  top: 0;
  left: 0;
  border-bottom: 1px solid #0D5F82;

  .product_module_items {
    width: 40%;
    margin: auto;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    padding: 20px 0;

    .p_m_item {
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      border: 1px solid #909399;
    }
  }

  .product_show {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .high_light {
    color: #fff;
    background-image: url('../../../../static/img/companyinfors/abu-bak.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/product/product.vue